<p-confirmPopup></p-confirmPopup>
<div class="card" style="min-height: 80vh;">
    <div class="flex w-full justify-content-between">
        <span style="font-size: 20px; font-weight: bold;">CURSOS CADASTRADOS</span>
        <div class="flex gap-2">
            <p-button label="Professores" icon="pi pi-address-book" (onClick)="showDialogTeachers=true"></p-button>
            <p-button label="Adicionar" icon="pi pi-plus" (onClick)="showDialogAdd=true"></p-button>
        </div>
    </div>

    <hr class="w-full my-3">

    <p-table
        styleClass="p-datatable-striped p-datatable-gridlines"
        [value]="courses"
        [paginator]="courses.length > 0"
        [rows]="8"
        [tableStyle]="{ 'min-width': '20rem' , 'width': '100%'}"
        [globalFilterFields]="['title', 'teacherId','price', 'description']">

        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="title">Título</th>
                <th pSortableColumn="teacherId">Professor</th>
                <th pSortableColumn="price">Preço</th>
                <th>Nº Módulos</th>
                <th pSortableColumn="description">Descrição </th>
                <th>Público</th>
                <th>Funções</th>
            </tr>
            <tr>
                <th>
                    <p-columnFilter 
                    type="text" 
                    field="title" 
                    matchMode="contains"
                    placeholder="Título"
                    ariaLabel="Filter title"
                    [showMenu]="false"
                    [showClearButton]="false" />
                </th>

                <th>
                    <p-columnFilter
                    matchMode="equals"
                    [showMenu]="false"
                    field="teacherId" 
                    [showClearButton]="false">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown
                        [options]="listTeachers"
                        optionLabel="name"
                        optionValue="id"
                        (onChange)="filter($event.value)"
                        placeholder="Professor"
                        [showClear]="true"
                        appendTo="body"
                        [style]="{ width: '100%' }"
                        ></p-dropdown>
                    </ng-template>
                    </p-columnFilter>
                </th>

                <th>
                    <p-columnFilter
                    type="text"
                    field="price"
                    matchMode="contains"
                    placeholder="Preço"
                    ariaLabel="Filter Name"
                    [showMenu]="false"
                    [showClearButton]="false" />
                </th>

                <th></th>

                <th>
                    <p-columnFilter
                    type="text"
                    field="description"
                    matchMode="contains"
                    placeholder="Descrição"
                    ariaLabel="Filter Name"
                    [showMenu]="false"
                    [showClearButton]="false" />
                </th>

                <th></th>
                <th></th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-course let-ri="rowIndex">
            <tr>
                <td>{{course.title}}</td>
                <td>{{course.teacher.name}}</td>
                <td>{{course.price | currency:'BRL':'symbol':'1.2-2'}}</td>
                <td>{{course.courseModules.length }} módulo(s)</td>
                <td>{{course.description}}</td>
                <td>
                    <p-button rounded [icon]="course.isPublic ? 'pi pi-eye': 'pi pi-eye-slash'" [severity]="course.isPublic ? 'info': 'danger'" text></p-button>
                </td>
                <td>
                    <div class="flex gap-2">
                        <p-button outlined icon="pi pi-search" rounded (onClick)="ShowCourseDetails(course)"></p-button>
                        <p-button outlined icon="pi pi-trash" severity="danger" rounded (onClick)="ConfirmDelete($event, course)"></p-button>
                    </div>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr *ngIf="loaded">
                <td colspan="7">
                    <div  style="height: 40vh;  display: flex;text-align: center;width: 100%;justify-content: center;align-items: center;flex-direction: column; ">
                        <div>
                            <ng-lottie [options]="animationNotFound"  width="12vw" height="12vw"/>
                        </div>
                        <h3 style="color:#ccc;" class="mt-0">
                            <i>
                                Nenhum curso cadastrado
                            </i>
                        </h3>
                    </div>
                </td>
            </tr>

            <tr *ngIf="!loaded">
                <td colspan="7">
                    <div class="flex justify-content-center align-items-center w-full" style="height: 40vh;">
                        <p-progressSpinner ariaLabel="loading" />
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<p-dialog header="Criar Curso" [draggable]="false" [closable]="true" [(visible)]="showDialogAdd" [style]="{minWidth:'30vw'}" [modal]="true">
    <app-add-new-course *ngIf="showDialogAdd" [listTeachers]="listTeachers" (showDialogCreate)="showDialogAdd = $event; GetCourses()"></app-add-new-course>
</p-dialog>

<p-dialog header="Professores" [draggable]="false" [closable]="true" [(visible)]="showDialogTeachers" [style]="{minWidth:'50vw'}" [modal]="true">
    <app-teachers *ngIf="showDialogTeachers" [listTeachers]="listTeachers"></app-teachers>
</p-dialog>

<p-dialog header="Detalhes do Curso" [draggable]="false" [closable]="true" [(visible)]="showCouseDetails" [style]="{width:'100%', minHeight:'100%'}" [modal]="true" (onHide)="selectedCourse=null">
    <app-course-details *ngIf="showCouseDetails" [listTeachers]="listTeachers" [selectedCourse]="selectedCourse!"></app-course-details>
</p-dialog>
